// Shared slug generator — used for article slugs and category slugs so URLs are
// consistent and typo-free. e.g. "Women's Health!" -> "womens-health".
const slugify = (s) =>
  String(s || "")
    .toLowerCase()
    .trim()
    .replace(/['"]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .slice(0, 80)
    .replace(/^-+|-+$/g, ""); // strip leading/trailing dashes AFTER truncation

export default slugify;
